import { reactive } from 'vue';

export const globalState = reactive({
  memberHoverPreviewShown: false,
  memberHoverTippyInstance: null,
  currentGroupAvatarId: null,
  currentGroupAvatarTimeout: null,
  showSuggestedActions: false,
  searchBoardQuery: '',
  bulkActionsInProgress: false,
});
